var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/warning",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999762,4.062538 C7.33598581,4.062538 3.56249627,7.84365691 3.56249627,12.5000179 C3.56249627,17.1655722 7.34201302,20.9374978 11.9999762,20.9374978 C16.6636232,20.9374978 20.437456,17.1598121 20.437456,12.5000179 C20.437456,7.81546637 16.6336016,4.062538 11.9999762,4.062538 Z M11.9999762,2.81254098 C17.3498474,2.81254098 21.6874531,7.15171063 21.6874531,12.5000179 C21.6874531,17.8514532 17.3498474,22.1874948 11.9999762,22.1874948 C6.65010488,22.1874948 2.31249925,17.8514532 2.31249925,12.5000179 C2.31249925,7.15171063 6.65010488,2.81254098 11.9999762,2.81254098 Z M11.5511399,7.5000298 L12.4487742,7.5000298 C12.7152683,7.5000298 12.9282042,7.72196836 12.9171035,7.98830989 L12.6436666,14.5507942 C12.6332144,14.801877 12.426649,15.0000119 12.1753374,15.0000119 L11.8245768,15.0000119 C11.5733033,15.0000119 11.3666998,14.8018389 11.3562094,14.5507942 L11.0827725,7.98830989 C11.0717481,7.72196836 11.2846077,7.5000298 11.5511399,7.5000298 Z M11.9999762,15.7812601 C12.604032,15.7812601 13.0937236,16.2709516 13.0937236,16.8750075 C13.0937236,17.4790633 12.604032,17.9687548 11.9999762,17.9687548 C11.3959203,17.9687548 10.9062288,17.4790633 10.9062288,16.8750075 C10.9062288,16.2709516 11.3959203,15.7812601 11.9999762,15.7812601 Z",
    id: "error-outline",
    fill: "#B4432F",
    fillRule: "nonzero"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.691c96fe.svg";
export { ForwardRef as ReactComponent };